export default "__VITE_ASSET__CuNKxUsg__"